module.exports = __webpack_public_path__ + "static/media/RNSSanz-Black.0c8c22fe.ttf";